(function($) {
"use strict";
	$.fn.overlayFitContent = function(title, onclose) {
		var content = $(this);

		var overlay = $(''
			+ '<div class="bbm-overlay-background bbm-overlay-fit-content">'
			+ '    <div class="bbm-overlay">'
			+ '        <div class="bbm-overlay-header">'
			+ '            <span class="bbm-overlay-title"></span>'
			+ '            <button type="button" class="bbm-overlay-close"><i class="material-icons">close</i></button>'
			+ '        </div>'
			+ '        <div class="bbm-overlay-content"></div>'
			+ '    </div>'
			+ '</div>'
		).appendTo(document.body);

		overlay.find('.bbm-overlay-title').text(title);
		overlay.find('.bbm-overlay-content').append(content);
		overlay.find('.bbm-overlay-close').click(function() {
			overlay.remove();
			if (onclose)
				onclose();
		});
	};
})(window.jQuery);